import { createRouter, createWebHistory } from 'vue-router';
import { routeAuthGuard } from './auth.router';

const Login = () => import('../views/Login.vue');
const Register = () => import('../views/Register/Register.vue');
const Orders = () => import('../views/Orders/Orders.vue');
const Materials = () => import('../views/Materials.vue');
const Invoices = () => import('../views/Invoices.vue');
const Profile = () => import('../views/Profile/Profile.vue');
const ForgottenPass = () => import('../views/ForgottenPass.vue');
const PasswordReset = () => import('../views/PasswordReset.vue');
const ListUsers = () => import('../views/admin/ListUsers/ListUsers.vue');
const ActiveOrders = () => import('../views/admin/Orders/ActiveOrders.vue');
const AllOrders = () => import('../views/admin/Orders/AllOrders.vue');
const AdminInvoices = () => import('../views/admin/Invoices/Invoices.vue');

// Admin
const MaterialsTable = () => import('../views/admin/MaterialsTable.vue');
const ColorsTable = () => import('../views/admin/ColorsTable.vue');
const Prices = () => import('../views/admin/Prices.vue');
const Files = () => import('../views/admin/Files.vue');
const News = () => import('../views/admin/News.vue');

const routes = [
  { path: '/', name: 'home' },
  // LOGIN
  { path: '/login', name: 'login', component: Login },
  { path: '/register', name: 'register', component: Register },
  { path: '/forgotten-password', name: 'forgottenPass', component: ForgottenPass },
  { path: '/password-reset', name: 'passReset', component: PasswordReset },
  // USER
  { path: '/orders', name: 'orders', component: Orders, meta: { defQuery: { pagination: true, sortingCreated: true }, access: 'User' } },
  { path: '/invoices', name: 'invoices', component: Invoices, meta: { defQuery: { pagination: true }, access: 'User' } },
  { path: '/materials', name: 'materials', component: Materials, meta: { access: 'User' } },
  { path: '/profile', name: 'profile', component: Profile, meta: { access: 'All' } },
  // ADMIN
  {
    path: '/admin',
    children: [
      {
        path: 'orders',
        name: 'adminOrders',
        component: AllOrders,
        meta: { defQuery: { pagination: true, sortingCreated: true }, access: 'Moderator' },
      },
      {
        path: 'invoices',
        name: 'adminInvoices',
        component: AdminInvoices,
        meta: { defQuery: { pagination: true }, access: 'Admin' },
      },
      {
        name: 'adminMaterials',
        path: 'materials',
        component: MaterialsTable,
        meta: { access: 'Moderator' },
      },
      {
        name: 'adminColors',
        path: 'colors',
        component: ColorsTable,
        meta: { access: 'Moderator' },
      },
      {
        path: 'active-orders',
        name: 'activeOrders',
        component: ActiveOrders,
        meta: { access: 'Moderator' },
      },
      {
        name: 'adminPrices',
        path: 'prices',
        component: Prices,
        meta: { access: 'Admin' },
      },
      {
        path: 'users',
        name: 'listUsers',
        component: ListUsers,
        meta: { access: 'Admin' },
      },
      {
        path: 'files',
        name: 'files',

        component: Files,
        meta: { defQuery: { pagination: true }, access: 'Admin' },
      },
      {
        path: 'news',
        name: 'news',
        component: News,
        meta: { defQuery: { pagination: true }, access: 'Admin' },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes: routes as any,
});

router.beforeEach(routeAuthGuard);

export default router;
